<script>
import baseList from "@/views/components/base/baseList.vue";
let customerId = window.localStorage.getItem("customerId")
import IncreaseView from "./increase.vue";
import EditView from "./edit.vue";

export default {
  extends: baseList,
  components: {
    IncreaseView,
    EditView,
  },
  data() {
    return {
      table: {
        mname: "attendance",
        key: "id",
        url: {
          list: "admin/system/classes/list",
          del: "admin/system/classes",
        },
        output: false,
      },
      actions: [
        {
          label: "新增考勤组",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
          auth: "",
        },
      ],
      filters: [
        {
          label: "考勤组",
          name: "name",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
      ],
      menus: [
        {
          label: "排班管理",
          name: "scheduling_list",
          auth: "",
        },
        {
          label: "考勤组",
          name: "attendance_list",
          auth: "",
        },
      ],
      tableCols: [
        {
          key: "name",
          title: "名称",
          width: 300,
          align: "center",
        },
        // {
        //   key: "numbers",
        //   title: "人数",
        //   width: 200,
        //   align: "center",
        //   render: (h, params) => {
        //     const row = params.row;
        //     const text = row.engineerNameList.length;
        //     return <span>{text}</span>;
        //   },
        // },
        {
          title: "类型",
          width: 200,
          align: "center",
          render: (h, params) => {
            return <div>{params.row.isDefault == 1 ? "默认班次" : "班次"}</div>;
          },
        },
        {
          title: "考勤时间",
          width: 500,
          align: "center",
          render: (h, p) => {
            let item = p.row;
            return (
              <div>
                {item.workdayName} {item.workStartTime}-{item.workEndTime}
              </div>
            );
          },
        },
        {
          title: "操作",
          align: "center",
          key: "handle",
          handle: [
            (vm, h, currentRow, param) => {
              return (
                <Button
                  size="small"
                  onClick={() => this.tobianji(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                  }}
                >
                  编辑
                </Button>
              );
            },
            "delete",
          ],
        },
      ],
    };
  },
  created() { },
  methods: {
    toAdd() {
      this.$Modal.success({
        closable: true,
        title: "新增考勤组",
        width: "800px",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <IncreaseView
                onOnCancel={() => {
                  this.onCancel();
                }}
              />
            </div>
          );
        },
      });
    },
    onCancel() {
      this.$Modal.remove();
      this.search();
    },
    tobianji(row) {
      this.$Modal.success({
        closable: true,
        title: "编辑考勤组",
        width: "800px",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <EditView
                onOnCancel={() => {
                  this.onCancel();
                }}
                Id={row.id}
              />
            </div>
          );
        },
      });
    },
  },
};
</script>

<style></style>
